import { useState } from "react";
import { MdMenu, MdClose } from "react-icons/md";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const Navbar = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const navigation = [
    { name: "Home", route: "/" },
    { name: "Cultivars", route: "/cultivars" },
    { name: "About", route: "/about" },
    { name: "Contact", route: "/contact" },
  ];

  return (
    <motion.header
      className="bg-black text-white shadow-md sticky top-0 z-50"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ type: "spring", stiffness: 200, damping: 20 }}
    >
      <div className="container mx-auto flex items-center justify-between p-8 px-14">
        {/* Logo */}
        <div className="text-2xl font-bold">
          <Link to="/" className="hover:text-green-500 transition-all">
            <img src="/logo.svg" alt="Logo" className="h-10" />
          </Link>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex space-x-10 px-14">
          {navigation.map((menu, index) => (
            <motion.div
              key={index}
              className="relative group"
              whileHover={{ scale: 1.1 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <Link
                to={menu.route}
                className="text-lg font-semibold hover:text-green-500 transition-all"
              >
                {menu.name}
              </Link>
              <motion.div className="absolute bottom-0 left-0 w-full h-[2px] bg-green-500 transform scale-x-0 origin-left transition-all duration-300 group-hover:scale-x-100" />
            </motion.div>
          ))}
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="lg:hidden text-2xl focus:outline-none"
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        >
          <MdMenu />
        </button>
      </div>

      {/* Mobile Sidebar */}
      <AnimatePresence>
        {isSidebarOpen && (
          <motion.div
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ type: "spring", stiffness: 100 }}
            className="fixed top-0 right-0 h-full w-2/3 bg-black text-white z-20 shadow-lg"
          >
            <div className="p-4 space-y-4">
              {/* Close Button */}
              <button
                className="text-2xl focus:outline-none text-green-500"
                onClick={() => setIsSidebarOpen(false)}
              >
                <MdClose />
              </button>
              {navigation.map((menu, index) => (
                <motion.div
                  key={index}
                  className="relative group"
                  whileHover={{ scale: 1.1 }}
                  transition={{ type: "spring", stiffness: 300 }}
                >
                  <Link
                    to={menu.route}
                    className="text-lg font-semibold hover:text-green-500 transition-all"
                  >
                    {menu.name}
                  </Link>
                </motion.div>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};

export default Navbar;
